<template>
  <div class="compnent-wrap_screen_share_person_list" v-drag="true">
    <div class="screen-share-person-list" v-show="!collapsed">
      <!-- 顶部拖拽区域 -->
      <div class="drag-area drag-handle">
        <div class="mode-switch">
          <el-tooltip
            v-for="mode in modes"
            :key="mode.value"
            class="item"
            effect="dark"
            :content="mode.tips"
            placement="top-start"
          >
            <div
              class="mode-item"
              @click="handleModeChange(mode.value)"
              :aria-label="mode.label"
              tabindex="0"
            >
              <img
                v-if="currentMode === mode.value"
                :src="mode.selectIcon"
                :alt="mode.label"
                class="mode-icon"
              />
              <img
                v-else
                :src="mode.defaultIcon"
                :alt="mode.label"
                class="mode-icon"
              />
            </div>
          </el-tooltip>
        </div>
        <el-tooltip effect="dark" content="收起" placement="top-start">
          <div
            class="collapse-btn"
            icon="el-icon-minus"
            @click="handleCollapse"
            aria-label="收起"
            tabindex="0"
          >
            <img src="@saas/pages/assets/images/live/hide.png" alt="" />
          </div>
        </el-tooltip>
      </div>
      <!-- 内容区域 -->
      <div class="content-area">
        <div v-show="currentMode === 1" class="mode-content mode1 ellipsis">
          <!-- 第一种模式内容，根据 Figma 18-3750 设计实现 -->
          正在讲话：{{ speakerInfo.name }}
        </div>
        <!-- <div v-show="currentMode === 2" class="mode-content mode2">
          <teacher-video
            v-if="currentMode === 2"
            :teacher-info="teacherInfo"
          ></teacher-video>
        </div> -->
        <div
          v-show="currentMode === 3 || currentMode === 2"
          class="mode-content mode3"
        >
          <!-- 第三种模式内容：人员列表，固定高度，超出可滚动 -->
          <div
            class="scroll-arrow up"
            v-if="showUpArrow"
            @click="handleScrollUp"
            aria-label="向上滚动"
            tabindex="0"
          >
            <i class="el-icon-arrow-up"></i>
          </div>
          <div
            class="person-list-wrapper"
            ref="personListWrapper"
            :style="{ maxHeight: listMaxHeight + 'px' }"
            @scroll="handleScroll"
          >
            <ul class="person-list">
              <li v-if="shouldShowPersonVideo" class="person-item">
                <teacher-video :teacher-info="teacherInfo"></teacher-video>
              </li>
              <li
                v-show="shouldShowPersonVideo && currentMode === 3"
                v-for="person in studentList"
                :key="person.userID"
                class="person-item"
              >
                <student-video :student-info="person"></student-video>
              </li>
            </ul>
          </div>
          <div
            class="scroll-arrow down"
            v-if="showDownArrow"
            @click="handleScrollDown"
            aria-label="向下滚动"
            tabindex="0"
          >
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="collapsed"
      class="collapsed-icon"
      @click="handleExpand"
      tabindex="0"
      aria-label="展开"
    >
      <img v-if="speakerInfo.userID" :src="collapsedIconColor" alt="展开" />
      <img v-else :src="collapsedIcon" alt="展开" />
    </div>
  </div>
</template>

<script>
import { drag } from "@saas/components/src/utils/drag.js";
import StudentVideo from "../person-list/StudentVideo.vue";
import TeacherVideo from "../person-list/TeacherVideo.vue";
import { mapState } from "vuex";
import screenShareMixins from "../mixins/screen-share";
export default {
  name: "ScreenSharePersonList",
  mixins: [screenShareMixins],
  directives: {
    drag,
  },
  components: {
    StudentVideo,
    TeacherVideo,
  },
  data() {
    return {
      collapsed: false,
      currentMode: 1, // 1 隐藏, 2 只展示老师, 3:全部人员列表
      modes: [
        {
          value: 1,
          label: "模式一",
          defaultIcon: require("@saas/pages/assets/images/live/line-1_default.png"),
          selectIcon: require("@saas/pages/assets/images/live/line-1_select.png"),
          tips: "隐藏上台人员",
        },
        {
          value: 2,
          label: "模式二",
          defaultIcon: require("@saas/pages/assets/images/live/line-2_default.png"),
          selectIcon: require("@saas/pages/assets/images/live/line-2_select.png"),
          tips: "只显示老师",
        },
        {
          value: 3,
          label: "全部",
          defaultIcon: require("@saas/pages/assets/images/live/line-3_default.png"),
          selectIcon: require("@saas/pages/assets/images/live/line-3_select.png"),
          tips: "显示上台所有人",
        },
      ],
      collapsedIcon: require("@saas/pages/assets/images/live/show-default.png"),
      collapsedIconColor: require("@saas/pages/assets/images/live/show-color.png"),
      listMaxHeight: 550, // 固定高度，可根据设计调整
      showUpArrow: false,
      showDownArrow: false,
      speakerInfo: {},
      speakerTimer: null,
    };
  },
  computed: {
    ...mapState("live", [
      "membersStatus",
      "liveService",
      "roomInfo",
      "userStatus",
      "isRecordPage",
    ]),
    teacherInfo() {
      return this.membersStatus.find((item) => item.isTeacher) || {};
    },
    allList() {
      return JSON.parse(JSON.stringify(this.membersStatus));
    },
    studentList() {
      return this.membersStatus.filter((item) => !item.isTeacher);
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    // 是否应该显示人员视频模块（快直播下台学生或助教不显示，因为 CDN 流已包含）
    shouldShowPersonVideo() {
      // 快直播下台学生或助教不显示视频模块
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage !== 1 &&
        !this.isRecordPage
      ) {
        return false;
      }
      return true;
    },
  },

  mounted() {
    this.updateArrows();
  },
  methods: {
    handleModeChange(mode) {
      this.currentMode = mode;
      this.$nextTick(this.updateArrows);
    },
    handleCollapse() {
      this.collapsed = true;
    },
    handleExpand() {
      this.collapsed = false;
      this.$nextTick(this.updateArrows);
    },
    handleScroll() {
      this.updateArrows();
    },
    handleScrollUp() {
      const wrapper = this.$refs.personListWrapper;
      if (!wrapper) return;
      const targetTop = Math.max(wrapper.scrollTop - 84, 0);
      wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
    },
    handleScrollDown() {
      const wrapper = this.$refs.personListWrapper;
      if (!wrapper) return;
      const targetTop = Math.min(
        wrapper.scrollTop + 84,
        wrapper.scrollHeight - wrapper.clientHeight
      );
      wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
    },
    updateArrows() {
      if (this.currentMode !== 3) return;
      const wrapper = this.$refs.personListWrapper;
      if (!wrapper) return;
      this.showUpArrow = wrapper.scrollTop > 0;
      this.showDownArrow =
        wrapper.scrollTop + wrapper.clientHeight < wrapper.scrollHeight;
    },
    // 监听音量变化
    onVolumeChange() {
      if (this.liveService) {
        this.liveService.on("audioVolumnChange", (res) => {
          if (res.volume > 0) {
            let info = {};
            if (res.userId === "") {
              info =
                this.membersStatus.find(
                  (item) => item.userID === this.userInfo.user_id
                ) || {};
            } else {
              info =
                this.membersStatus.find((item) => item.userID === res.userId) ||
                {};
            }
            this.onSpeakerChange(info);
          }
        });
        // this.liveService.enableAudioVolumeEvaluation();
      } else {
        console.error(
          "屏幕共享 头像列表 监听音量变化失败————liveService 没找到"
        );
      }
    },
    //
    onSpeakerChange(info) {
      this.speakerInfo = info;
      clearTimeout(this.speakerTimer);
      this.speakerTimer = setTimeout(() => {
        this.speakerInfo = {};
      }, 500);
    },
  },
  watch: {
    currentMode() {
      this.$nextTick(this.updateArrows);
    },
    liveService: {
      handler(val) {
        if (val) {
          this.onVolumeChange();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.compnent-wrap_screen_share_person_list {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 100px;
  right: 60px;
}
.screen-share-person-list {
  background: #18181b;
  width: 164px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  .drag-area {
    display: flex !important;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    cursor: move;
    padding: 10px;
    .mode-switch {
      display: flex;
      .mode-item {
        cursor: pointer;
        margin-right: 10px;
        .mode-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .collapse-btn {
      width: 20px;
      height: 20px;
    }
  }
  .content-area {
    flex: 1;
    padding: 0 4px;
    display: flex;
    justify-content: center;
    .mode-content {
      &.mode1 {
        flex: 1;
        height: 38px;
        line-height: 38px;
        font-weight: 500;
        font-size: 14px;
        color: #f7f8fa;
        border-top: 1px solid #27272a;
        padding: 0 8px;
        text-align: left;
      }
      &.mode1,
      &.mode2 {
        // 可根据 Figma 设计细化
        padding-bottom: 2px;
      }
      &.mode3 {
        position: relative;
        padding-bottom: 0px;
        .scroll-arrow {
          width: 42px;
          height: 18px;
          background: rgba(63, 63, 70, 0.4);
          border-radius: 12px 12px 12px 12px;
          color: #fff;
          cursor: pointer;
          font-size: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99;
          &.up {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          &.down {
            position: absolute;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .person-list-wrapper {
          overflow-y: auto;
          max-height: 550px;
          &::-webkit-scrollbar {
            width: 0;
          }
        }
        .person-list {
          list-style: none;
          margin: 0;
          padding: 0;
          .person-item {
            display: flex;
            align-items: center;
            padding: 2px 0;
            .avatar {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              margin-right: 12px;
            }
            .name {
              font-size: 16px;
              color: #333;
            }
          }
        }
      }
    }
  }
}
.collapsed-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
